import { render, staticRenderFns } from "./companyApproveFinish.vue?vue&type=template&id=23c7ce36&scoped=true"
import script from "./companyApproveFinish.vue?vue&type=script&lang=ts"
export * from "./companyApproveFinish.vue?vue&type=script&lang=ts"
import style0 from "./companyApproveFinish.vue?vue&type=style&index=0&id=23c7ce36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c7ce36",
  null
  
)

export default component.exports